// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"09984408","129":"a6fbc1a1","133":"808d3191","201":"ce5df505","248":"e607965e","804":"68af5071","849":"a288a59b"}[chunkId] + ".chunk.js";
};